import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { FileExportsDrawerContainerComponent, EmptyReportContainerComponent } from '@mode/report-editor/shell';

export const DowngradedReportEditorShellModule = angular
  .module('downgraded-report-editor-shell', [])
  .directive('modeFileExportsDrawerContainer', downgradeComponent({ component: FileExportsDrawerContainerComponent }))
  .directive('modeEmptyReportContainer', downgradeComponent({ component: EmptyReportContainerComponent })).name;
